<script setup>

const modelValue = defineModel()

const { theme } = defineProps({
    theme: {
        type: String,
        default: 'light'
    },
    header: {
        type: String,
        default: 'Местоположение объекта'
    }
})
// console.log('offer / map', 'default', modelValue.value);

const isVisible = ref(false)
const zoom = ref(18)
const center = computed(() => {
    if( modelValue.value && parseFloat( modelValue.value.lat ) > 0 && parseFloat( modelValue.value.lon ) > 0 ){
        // console.log('offer / map', [parseFloat( modelValue.value.lon ), parseFloat( modelValue.value.lat )]);
        return [parseFloat( modelValue.value.lon ), parseFloat( modelValue.value.lat )]
    }else{
        // console.log('offer / map', 'default', modelValue.value);
        return [36, 53]
    }
})

import {
    YandexMap,
    YandexMapControls,
    YandexMapDefaultMarker,
    YandexMapDefaultFeaturesLayer,
    YandexMapDefaultSchemeLayer,
    YandexMapZoomControl,
} from "vue-yandex-maps";

onMounted( () => {
    isVisible.value = true   
})

</script>
<template>
    <div>
        <yandex-map
            v-if="isVisible" 
            :settings="{
                location: {
                    center,
                    zoom,
                },
                showScaleInCopyrights: true,
            }"
            width="100%"
            height="500px"
        >
            <yandex-map-default-scheme-layer :settings="{ theme }" />
            <yandex-map-default-features-layer/>
            <yandex-map-controls :settings="{ position: 'right' }">
                <yandex-map-zoom-control />
            </yandex-map-controls>
            <yandex-map-default-marker
                :settings="{
                    coordinates: center,
                    title: header,
                    color: '#00b6f4',
                    popup: { position: 'top' },
                }"
            >
                <template #popup="{ close }"> </template>
            </yandex-map-default-marker>
        </yandex-map>
    </div>
</template>